import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "data-ingestion-history-card__header"
};
const _hoisted_2 = { class: "data-ingestion-history-card__header__title" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("i", {
    class: "icon icon-question-12px",
    "data-cy": "data-ingestion-history-icon-tooltip"
}, null, -1);
import { computed } from 'vue';
import Alert from '@/components/_atoms/Alert.vue';
import DataIngestionHistoryExportButton from './DataIngestionHistoryExportButton.vue';
import DataIngestionHistoryTable from './DataIngestionHistoryTable.vue';
import LoaderSpinner from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import { formatDate } from '@/utilities/formatters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataIngestionHistoryCard',
    props: {
        data: {},
        columns: {},
        loading: { type: Boolean },
        error: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const state = computed(() => {
            return {
                date: props.data[0],
                status: props.data[1]['status'],
                history: props.data[1]['history'],
                alerts: props.data[1]['alerts'],
                columns: props.columns || [],
            };
        });
        const shouldDisplayEmptyStateWithoutTable = computed(() => {
            return !props.loading && props.error && !state.value.columns?.length;
        });
        const showDisplayEmptyStateWithTable = computed(() => {
            return !props.loading && state.value.columns?.length && !props.data[1];
        });
        const fullErrorsTable = computed(() => {
            return state.value.history.every(value => value.status === 'error');
        });
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-ingestion-history-card", {
                        'data-ingestion-history-card--error': shouldDisplayEmptyStateWithoutTable.value,
                        'data-ingestion-history-card--empty-error': showDisplayEmptyStateWithTable.value,
                    }])
            }, [
                (!props.loading && !shouldDisplayEmptyStateWithoutTable.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!props.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("h2", {
                                        class: _normalizeClass(`data-ingestion-history-card__header__title--${state.value.status}`),
                                        "data-cy": "data-ingestion-history-header-date"
                                    }, _toDisplayString(_unref(formatDate)(state.value.date, 'DD MMM YYYY')), 3),
                                    _createVNode(_component_el_popover, {
                                        trigger: "hover",
                                        placement: "right",
                                        width: 260
                                    }, {
                                        reference: _withCtx(() => [
                                            _hoisted_4
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("p", {
                                                innerHTML: _ctx.$t(`data-ingestion-history.status.${state.value.status}`),
                                                class: "data-ingestion-history-card__header--tooltip"
                                            }, null, 8, _hoisted_3)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                (!props.error && !fullErrorsTable.value)
                                    ? (_openBlock(), _createBlock(DataIngestionHistoryExportButton, {
                                        key: 0,
                                        date: state.value.date,
                                        status: state.value.status
                                    }, null, 8, ["date", "status"]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                            (!props.error)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.value.alerts, (alert, index) => {
                                    return (_openBlock(), _createBlock(Alert, {
                                        key: index,
                                        type: alert.status,
                                        message: alert.message,
                                        "data-cy": "data-ingestion-history-alert"
                                    }, null, 8, ["type", "message"]));
                                }), 128))
                                : _createCommentVNode("", true),
                            _createVNode(DataIngestionHistoryTable, {
                                data: state.value.history,
                                columns: state.value.columns,
                                status: state.value.status
                            }, null, 8, ["data", "columns", "status"])
                        ])
                    ], 64))
                    : _createCommentVNode("", true),
                (props.loading)
                    ? (_openBlock(), _createBlock(LoaderSpinner, {
                        key: 1,
                        class: "data-ingestion-history-card__loading"
                    }))
                    : _createCommentVNode("", true),
                (shouldDisplayEmptyStateWithoutTable.value)
                    ? (_openBlock(), _createBlock(InfoCard, {
                        key: 2,
                        "custom-title": _ctx.$t('data-ingestion-history.table.custom-title'),
                        "custom-message": _ctx.$t('data-ingestion-history.table.custom-message')
                    }, null, 8, ["custom-title", "custom-message"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
